import React from 'react';
import VendexAction from '../../../models/VendexAction';
import useEventListner from '../../useEventListner';
import { VendexButtonMeta } from '../../../models/VendexElement';
type Props = {
  id: string;
  actions?: VendexAction[];
  data: VendexButtonMeta;
};

const VendexButton: React.FC<Props> = ({ id, data, actions }) => {
  const ref = React.useRef<HTMLButtonElement>(null);
  useEventListner(ref, actions);

  return (
    <button ref={ref} id={id} data-vendex>
      {data ? data : ''}
    </button>
  );
};

export default VendexButton;
